import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'gif-compression-field',
	templateUrl: './gif-compression-field.component.html',
	styleUrls: ['./gif-compression-field.component.scss']
})
export class GifCompressionFieldComponent implements OnInit {
	@Input() componentData: any;
	@Input() isAdmin: boolean;
	compressionOptimize = 'none';
	compressionColorMethod = 'none';

	constructor() {}

	ngOnInit() {
		if (this.componentData.config.compression && this.componentData.config.compression.optimize) {
			this.compressionOptimize = this.componentData.config.compression.optimize;
		}
		if (this.componentData.config.compression && this.componentData.config.compression.colorMethod) {
			this.compressionColorMethod = this.componentData.config.compression.colorMethod;
		}
	}

	compressionSettings(event) {
		if (event.target.checked && !this.componentData.config.compression) {
			this.componentData.config.compression = {};
		} else if (!event.target.checked) {
			delete this.componentData.config.compression;
		}
	}

	setCompressionSelectValue(value, field) {
		if (value !== 'none') {
			this.componentData.config.compression[field] = value;
		} else {
			delete this.componentData.config.compression[field];
		}
	}

	checkNullValue(value, field) {
		if (value === null) {
			delete this.componentData.config.compression[field];
		}
	}
}
